import React, { useState } from "react";
import { X, ArrowLeft } from "lucide-react";
import { useCartContext } from "../context/CartContext";

const CheckoutPage = ({ isOpen, onClose }) => {
  // const sanitizeInput = (value) => {
  //   // Empêche les caractères spéciaux utilisés en injection XSS
  //   return value.replace(/[<>\/"'`;&]/g, "");
  // };

  const { cartItems, totalPrice } = useCartContext();

  const [formData, setFormData] = useState({
    fullName: "",
    email: "",
    cardNumber: "",
    expiry: "",
    cvc: "",
  });

  if (!isOpen) return null;

  // Fonction pour formater le numéro de carte
  const formatCardNumber = (value) => {
    const numbers = value.replace(/\D/g, "");
    const groups = numbers.match(/.{1,4}/g) || [];
    return groups.join(" ").substr(0, 19); // 19 caractères max (16 chiffres + 3 espaces)
  };

  // Fonction pour formater la date d'expiration
  const formatExpiry = (value) => {
    const numbers = value.replace(/\D/g, "");
    if (numbers.length >= 2) {
      return numbers.substr(0, 2) + "/" + numbers.substr(2, 2);
    }
    return numbers;
  };

  // Fonction pour formater le CVC
  const formatCVC = (value) => {
    return value.replace(/\D/g, "").substr(0, 3);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;

    let formattedValue = value;

    switch (name) {
      case "cardNumber":
        formattedValue = formatCardNumber(value);
        break;
      case "expiry":
        formattedValue = formatExpiry(value);
        break;
      case "cvc":
        formattedValue = formatCVC(value);
        break;
      default:
        formattedValue = value;
    }

    setFormData({
      ...formData,
      [name]: formattedValue,
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log("Processing payment:", formData);
  };

  return (
    <div className="fixed inset-0 z-[60] flex">
      <div className="fixed inset-0 bg-black/30" onClick={onClose} />

      <div className="relative w-full max-w-md bg-white h-full overflow-y-auto animate-slide-in-left">
        <div className="p-6">
          <div className="flex justify-between items-center mb-6">
            <div className="flex items-center gap-2">
              <button
                onClick={onClose}
                className="p-2 hover:bg-gray-100 rounded-full"
              >
                <ArrowLeft className="w-5 h-5 text-gray-600" />
              </button>
              <h2 className="text-2xl font-bold">Checkoutttt</h2>
            </div>
            <button
              onClick={onClose}
              className="p-2 hover:bg-gray-100 rounded-full"
            >
              <X className="w-6 h-6 text-gray-600" />
            </button>
          </div>

          {/* Récapitulatif du panier */}
          <div className="mb-8 border-b pb-4">
            <h3 className="text-lg font-semibold mb-4">Order Summary</h3>
            {cartItems.map((item) => (
              <div key={item.id} className="flex items-center gap-4 mb-4">
                <img
                  src={item.image ? item.image : "placeholder.jpg"}
                  alt={item.name}
                  className="w-16 h-16 object-cover rounded"
                />

                <div className="flex-1">
                  <h4 className="text-sm font-medium">{item.name}</h4>
                  <p className="text-sm text-gray-500">
                    ${item.selectedSize.price} x {item.quantity}
                  </p>
                </div>
                <span className="font-medium">
                  ${(item.selectedSize.price * item.quantity).toFixed(2)}
                </span>
              </div>
            ))}
            <div className="mt-4 pt-2 border-t">
              <p className="text-xl font-bold flex justify-between">
                <span>Total:</span>
                <span>${totalPrice}</span>
              </p>
            </div>
          </div>

          <form onSubmit={handleSubmit} className="space-y-6">
            <div>
              <label className="block text-sm font-medium mb-2">
                Full Name
              </label>
              <input
                type="text"
                name="fullName"
                value={formData.fullName}
                onChange={handleChange}
                className="w-full border rounded-lg p-2 focus:ring-2  focus:ring-green-600 focus:border-green-600"
                required
              />
            </div>

            <div>
              <label className="block text-sm font-medium mb-2">Email</label>
              <input
                type="email"
                name="email"
                value={formData.email}
                onChange={handleChange}
                className="w-full border rounded-lg p-2 focus:ring-2 focus:ring-green-600 focus:border-green-600"
                required
              />
            </div>

            <div>
              <label className="block text-sm font-medium mb-2">
                Card Number
              </label>
              <input
                type="text"
                name="cardNumber"
                value={formData.cardNumber}
                onChange={handleChange}
                className="w-full border rounded-lg p-2 focus:ring-2 focus:ring-green-600 focus:border-green-600"
                placeholder="1234 1234 1234 1234"
                maxLength={19}
                required
              />
            </div>

            <div className="grid grid-cols-2 gap-4">
              <div>
                <label className="block text-sm font-medium mb-2">
                  Expiry Date
                </label>
                <input
                  type="text"
                  name="expiry"
                  value={formData.expiry}
                  onChange={handleChange}
                  className="w-full border rounded-lg p-2 focus:ring-2 focus:ring-green-600 focus:border-green-600"
                  placeholder="MM/YY"
                  maxLength={5}
                  required
                />
              </div>
              <div>
                <label className="block text-sm font-medium mb-2">CVC</label>
                <input
                  type="text"
                  name="cvc"
                  value={formData.cvc}
                  onChange={handleChange}
                  className="w-full border rounded-lg p-2 focus:ring-2 focus:ring-green-600 focus:border-green-600"
                  placeholder="123"
                  maxLength={3}
                  required
                />
              </div>
            </div>

            <button
              type="submit"
              className="w-full bg-green-600 text-white py-3 rounded-lg font-medium hover:bg-green-700 transition-colors"
            >
              Pay ${totalPrice}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default CheckoutPage;
